// extracted by mini-css-extract-plugin
export var container = "styles-module__container___dQoJb";
export var staticMapImage = "styles-module__staticMapImage___xzHGa";
export var viewFullMap = "styles-module__viewFullMap___bEjIb";